
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 49 35","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(8 6)","fill":"#DAE0E8","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M0 24h41V0H0z"}}),_c('rect',{attrs:{"y":"14","width":"41","height":"15","rx":"3"}})]),_c('g',{attrs:{"stroke":"#171C26","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M1 1v21.81C1.265 26.27 3.453 28 7.564 28h28.059C39.208 27.702 41 25.972 41 22.81V1H1z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M41 1v3.301c-.518 3.036-2.042 5.097-4.572 6.184C33.898 11.57 28.755 13.743 21 17L5.567 10.485C2.522 9.607 1 7.115 1 3.01"}})]),_c('path',{attrs:{"fill":"#FFF","d":"M14 5h13v21H14z"}}),_c('path',{attrs:{"d":"M20.56 20.24c2.5 0 3.8-1.3 3.8-2.92 0-2.14-1.94-2.62-3.62-3-1.26-.3-2.36-.6-2.36-1.54 0-.86.82-1.46 2.14-1.46 1.24 0 2.3.52 2.88 1.22l.7-1.04c-.78-.78-1.94-1.4-3.58-1.4-2.3 0-3.6 1.28-3.6 2.78 0 2 1.86 2.44 3.5 2.82 1.3.32 2.48.66 2.48 1.72 0 .94-.8 1.6-2.28 1.6-1.32 0-2.54-.64-3.18-1.38l-.78 1.08c.98 1.04 2.32 1.52 3.9 1.52z","fill":"#171C26","fill-rule":"nonzero"}}),_c('path',{attrs:{"stroke":"#171C26","stroke-width":"1.5","stroke-linecap":"square","d":"M20.5 8.5v2M20.5 20.5v1"}})])])
          )
        }
      }
    